import { DocumentReference, NameValue } from '.';

export class FestivalUser {
    id: string;
    church: DocumentReference;
    role: string;
    email: string;
    
    ageGroupList: DocumentReference[];
    
    user: DocumentReference;
    userId: string;
    
    isAdmin: boolean;
    isReportViewer: boolean;
    
    isMemberCoordinator: boolean; //  Can manage member entry
    isFinanceCoordinator: boolean;

    isSportLeader: boolean; // Sport Committee (Diocese Sport Leader)
    isChurchApprover: boolean; // Sport Approver
    isSportCoordinator?: boolean; // Age Group sport coordinator (Church Sport Coordinator)
    sportList: NameValue[];

    activityList: NameValue[];
    isActivityLeader: boolean; // (Diocese Activity Leader)
    isActivityCoordinator?: boolean;
    isActivityApprover: boolean; // (Church Activity Coordinator)
    
    serviceYear: string;
    
    isActive: boolean;
    isDeleted: boolean;

    lastPasswordResetDate: Date | string;
}